import { toast } from '@youcan/celeste';

export function useFlash() {
  const page = usePage();
  const { t } = useI18n();

  function flash() {
    const values = page.props.flash;

    if (values?.success) {
      toast.success(t('common.toast.success'), {
        variant: 'fill',
        position: 'top-center',
        description: values.success,
      });
    }

    if (values?.error) {
      toast.error(t('common.toast.error'), {
        variant: 'fill',
        position: 'top-center',
        description: values.error,
      });
    }
  }

  watch(
    () => page.props.flash,
    () => nextTick(() => flash()),
    { deep: true, immediate: true },
  );
}
